export default __webpack_public_path__ + "static/exotica-5386701203ecffde14f0595610293ef9.png";